export default "__VITE_ASSET__DWV$Y0uS__"